var m = Object.defineProperty, u = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var p = (o, t, s) => t in o ? m(o, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : o[t] = s, r = (o, t) => {
  for (var s in t || (t = {}))
    f.call(t, s) && p(o, s, t[s]);
  if (e)
    for (var s of e(t))
      x.call(t, s) && p(o, s, t[s]);
  return o;
}, n = (o, t) => u(o, i(t));
import { jsx as I } from "react/jsx-runtime";
import "react";
import { f as l, u as T } from "./factory-ueRxoNOV.js";
import { I as a } from "./InputBase-Cabx1d9o.js";
const _ = {}, c = l((o, t) => {
  const s = T("TextInput", _, o);
  return /* @__PURE__ */ I(a, n(r({ component: "input", ref: t }, s), { __staticSelector: "TextInput" }));
});
c.classes = a.classes;
c.displayName = "@mantine/core/TextInput";
export {
  c as T
};
